const axios = require("axios");
import Authentication  from "@/services/Authentication"

export default class JwtMiddleware {

    static config() {
        axios.interceptors.request.use(function (config) {

            const token = Authentication.getToken();
            config.headers.Authorization = token ? `Bearer ${token}` : '';
            return config;

        })
    }
}